import { Provider as CalendarTokenV2ApiProvider } from '../../clients/CalendarTokenClientV2/generated/CalendarTokenClientV2/types';
import { CalendarProvider } from '../../commonTypes';
export function calendarTokenV2ApiProviderToCalendarProvider(provider) {
  switch (provider) {
    case CalendarTokenV2ApiProvider.GOOGLE:
      return CalendarProvider.GOOGLE;
    case CalendarTokenV2ApiProvider.ICLOUD:
      return CalendarProvider.ICLOUD;
    case CalendarTokenV2ApiProvider.MICROSOFT:
      return CalendarProvider.MICROSOFT;
    default:
      throw new Error('unknown calendar provider');
  }
}
export function calendarProviderToCalendarTokenV2ApiProvider(provider) {
  switch (provider) {
    case CalendarProvider.GOOGLE:
      return CalendarTokenV2ApiProvider.GOOGLE;
    case CalendarProvider.ICLOUD:
      return CalendarTokenV2ApiProvider.ICLOUD;
    case CalendarProvider.MICROSOFT:
      return CalendarTokenV2ApiProvider.MICROSOFT;
    default:
      return CalendarTokenV2ApiProvider.PROVIDER_UNKNOWN;
  }
}
//# sourceMappingURL=converters.v2.js.map